export const ROLES = {
  ADMIN: 0,
  PGM: 1,
  PM: 2,
  MONITOR: 3,
  READER: 4,
};

export const DEFAULT_TIMEOUT = 10000;
